import React from "react";
import { compose } from "redux";
import Star from "@material-ui/icons/Star";
import { Field } from "redux-form/immutable";

import ModalTab from "app/components/Modal/ModalTab";
import ModalTabs from "app/components/Modal/ModalTabs";
import { QUALIFICATION_FORM } from "features/planner/planner.constants";

const QualificationModalTabs = () => (
  <ModalTabs>
    <Field
      name={QUALIFICATION_FORM.BACKCOLOR}
      component={({ input }) => (
        <ModalTab disabled>
          <Star
            style={{
              fill: input.value,
            }}
          />
        </ModalTab>
      )}
    ></Field>
  </ModalTabs>
);

export default compose()(QualificationModalTabs);
